export default {"src":"/_next/static/media/human-risk-management.09332fe1.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};